import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import UsageAnalyticsSection from '../../components/dashboard/UsageAnalyticsSection';

const UsageAnalytics = () => {
  return (
    <div className="space-y-6 md:space-y-8">
      {/* Compact sub-page header with back button to the Admin Dashboard */}
      <div className="flex items-center gap-4">
        <Link
          to="/admin/dashboard"
          aria-label="Back to Admin Dashboard"
          title="Back to Admin Dashboard"
          className="icon-button-admin flex-shrink-0"
        >
          <ArrowLeft className="w-5 h-5" />
        </Link>
        <div className="min-w-0">
          <h1 className="text-2xl font-bold text-gray-900 truncate mb-1">Platform Usage &amp; Adoption</h1>
          <p className="text-sm text-gray-500">
            Quantifiable usage of every key workflow — clock-ins, leave, documents, OCR, logins &amp; more
          </p>
        </div>
      </div>

      <UsageAnalyticsSection />
    </div>
  );
};

export default UsageAnalytics;
